import React, {useEffect, useRef, useState} from "react";
import {Alert, Button, Card, Empty, Input, Select, Tag, Typography} from "antd";
import {SearchOutlined,} from "@ant-design/icons";

import {URLS} from "@/lib/urls";
import AdminLayout from "@/components/layout/admin/adminLayout";
import {
    useApiCreateAdminProductDeliveryActionDeliver, useApiCreateAdminProductDeliveryActionDeliverToLesson,
    useApiSearchAdminProducts,
    useApiSearchAdminProductsDeliveryOnly, useApiSearchAdminProductsDeliveryToLesson
} from "@/api/product";
import ApiHandleSuccessMessage, {ApiHandleErrorMessage} from "@/lib/helper/apiHandleResultMessage";
import {ShoppingBagIcon} from "lucide-react";
import RenderIf from "@/components/render-if";
import {getJalaliDateTime} from "@/lib/utils/date";
import {hasPermission} from "@/components/can/Can";
import PermList from "@/lib/helper/PermList";

const {Title, Text} = Typography;

function AdminProductReceiptSearchAndDeliver() {
    const [keyword, setKeyword] = useState("");
    const [search, setSearch] = useState("");
    const [deliverNow, setDeliverNow] = useState(false)
    const ref = useRef(null);

    const STORAGE_KEY = "selected_products";


    const [productIds, setProductIds] = useState(() => {
        const value = localStorage.getItem(STORAGE_KEY);
        return value ? JSON.parse(value) : [];
    });

    const { data: products } = useApiSearchAdminProducts({per_page: 1000, status: 'published'});
    const {data, isLoading, refetch} = useApiSearchAdminProductsDeliveryToLesson({
        search: search,
        // product_ids: productIds,
        type: 'deliver'
    });


    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === "F4") {
                event.preventDefault();

                setSearch("");
                setKeyword("");
                ref?.current?.focus()
                setDeliverNow(false)
            }
        };

        window.addEventListener("keydown", handleKeyDown);

        return () => {
            window.removeEventListener("keydown", handleKeyDown);
        };
    }, []);




    const {mutate: deliveryAction, isPending: isPendingAction} = useApiCreateAdminProductDeliveryActionDeliverToLesson()


    useEffect(() => {

        if(data?.data?.product_deliver_step?.status === 'print'){
            handleDeliver()
        }
    }, [data?.data])



    function handleDeliver() {

        deliveryAction({
            action: 'deliver',
            code: search,
            lesson_id: data?.data?.data?.lesson_id,
            id: data?.data?.data?.id,
            // product_id: data?.data?.data?.product_id,
        }, {
            onSuccess: (r) => {
                ApiHandleSuccessMessage(r)
                setDeliverNow(true)
                refetch()

            },
            onError: (e) => {
                ApiHandleErrorMessage(e)
            }
        })


    }

    const saveProductInLocalStorage = (values) => {
        if(hasPermission(PermList.PRODUCT_DELIVERY_STEP_ADD))
        {
            setProductIds(values);
            localStorage.setItem(
                STORAGE_KEY,
                JSON.stringify(values)
            );
        }

    };
    return (
        <AdminLayout
            backTo={URLS.admin.products.dashboard}
            pageTitle="تحویل فیزیکی اقلام به مربیان"
        >
            <div className=" flex items-center justify-center p-6">

                <Card
                    className="w-full max-w-4xl rounded-3xl shadow-xl border-0"
                    bodyStyle={{padding: 40}}
                >
                    <div className="mb-8 hidden">
                        <Text className="block mb-2">
                            در حال تحویل چه محصول یا محصولاتی هستید؟
                        </Text>

                        <Select
                            mode="multiple"
                            size="large"
                            className="w-full"
                            placeholder="انتخاب محصولات"
                            value={productIds}
                            disabled={!hasPermission(PermList.PRODUCT_DELIVERY_STEP_ADD)}
                            options={
                                products?.data?.data?.map(item => ({
                                    label: item.title,
                                    value: item.id,
                                })) ?? []
                            }
                            onChange={(values) => {
                                saveProductInLocalStorage(values)
                            }}
                        />
                    </div>

                    {/* سرچ */}
                    <div className="text-center mb-10">

                        <Title level={2} className="!mb-2">
                            جستجوی کد تحویل مربی
                        </Title>

                        <Text type="secondary">
                            کد تحویل مربی را وارد کنید
                        </Text>
                        <br/>
                        <RenderIf condition={data?.data?.data?.id}>
                            <Text type="secondary">
                                برای پیدا کردن مورد بعدی کلید
                                <kbd>F4</kbd>
                                را بزنید
                            </Text>
                        </RenderIf>


                        <div className="mt-8 flex justify-center">
                            <Input.Search
                                size="large"
                                ref={ref}
                                disabled={!productIds.length}
                                allowClear

                                enterButton={
                                    <>
                                        <SearchOutlined/>
                                        جستجو
                                    </>
                                }
                                loading={isLoading}
                                value={keyword}
                                placeholder="جستجو کنید ..."
                                className="max-w-xl"
                                onChange={(e) => {
                                    setKeyword(e.target.value)
                                    setDeliverNow(false)
                                }}
                                onSearch={(v) => setSearch(v.trim())}
                            />
                        </div>
                    </div>

                    {/* هنوز سرچ نشده */}
                    {!search && (
                        <Empty
                            image={Empty.PRESENTED_IMAGE_SIMPLE}
                            description="برای مشاهده اطلاعات کد تحویل مربی را جستجو کنید."
                        />
                    )}
                    {search && !data?.data?.product_deliver_step?.id && (
                        <Alert type="info"
                               description={
                                   <>
                                       <div className={'text-center '}>یا رسید دریافت آن صادر نشده است</div>
                                   </>}
                               message={<>
                                   <div className={'text-center text-2xl font-bold'}>کد تحویل جستجو شده یافت نشد!</div>
                               </>}
                        ></Alert>
                    )}

                    <RenderIf condition={deliverNow}>
                        <div className={'my-2'}>
                            <Alert type="success"

                                   message={<>
                                       <div className={'text-center text-2xl font-bold'}>ثبت تحویل انجام شد</div>
                                   </>}
                            ></Alert>
                        </div>
                    </RenderIf>

                    <RenderIf condition={data?.data?.product_deliver_step?.status === 'delivered' && !deliverNow}>
                        <div className={'my-2'}>
                            <Alert type="error"

                                   message={<>
                                       <div className={'text-center text-2xl font-bold text-red-500'}>ثبت تحویل قبلا انجام شده است</div>
                                   </>}
                            ></Alert>
                        </div>

                    </RenderIf>

                    <RenderIf condition={data?.data?.product_deliver_step?.id}>

                        <Card className="mb-6 rounded-2xl  ">

                            <div className="grid grid-cols-2 gap-6">

                                <div>
                                    <Text type="secondary">نام</Text>

                                    <div className="font-bold text-lg">
                                        {data?.data?.product_deliver_step?.lesson?.teacher_detail?.firstname}
                                    </div>
                                </div>

                                <div>
                                    <Text type="secondary">نام خانوادگی</Text>

                                    <div className="font-bold text-lg">
                                        {data?.data?.product_deliver_step?.lesson?.teacher_detail?.lastname}
                                    </div>
                                </div>
                                <div>
                                    <Text type="secondary">موبایل</Text>

                                    <div className="font-bold text-lg">
                                        {data?.data?.product_deliver_step?.lesson?.teacher_detail?.mobile}
                                    </div>
                                </div>


                                <div>
                                    <Text type="secondary">محصول</Text>

                                    <div className="font-bold text-xl">
                                        {data?.data?.data?.product?.title}
                                    </div>
                                </div>

                                <div>
                                    <Text type="secondary">کد تحویل</Text>

                                    <div>
                                        {data?.data?.product_deliver_step?.code}
                                    </div>
                                </div>



                            </div>

                        </Card>

                        <div className="text-center">

                            <RenderIf condition={data?.data?.product_deliver_step?.status === 'print'}>

                                <Button
                                    size="large"
                                    color="green"
                                    variant="solid"
                                    loading={isPendingAction}
                                    onClick={handleDeliver}
                                    icon={<ShoppingBagIcon />}
                                >
                                    تحویل اقلام
                                </Button>
                            </RenderIf>


                        </div>

                    </RenderIf>

                </Card>
            </div>


        </AdminLayout>
    );
}

export default AdminProductReceiptSearchAndDeliver;